import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import Shell from "../components/Shell";
import { fetchGrokFlags, updateGrokFlags, fetchGrokReport, runGrokBackfill, API } from "../lib/api";
import { FlagsPanel } from "../components/grok/FlagsPanel";
import { ReportPanel } from "../components/grok/ReportPanel";
import { LeadsPanel } from "../components/grok/LeadsPanel";
import { DraftsPanel } from "../components/grok/DraftsPanel";
import { TokensPanel } from "../components/grok/TokensPanel";
import { WebhooksPanel } from "../components/grok/WebhooksPanel";
import { Report7dPanel } from "../components/grok/Report7dPanel";

const ENDPOINTS = [
  "GET  /grok/wa/leads?status=&needs_answer=&q=", "GET  /grok/wa/leads/{id}", "GET  /grok/wa/leads/{id}/thread",
  "POST /grok/wa/leads/{id}/status", "POST /grok/wa/leads/{id}/reply", "POST /grok/wa/leads/{id}/drafts",
  "POST /grok/wa/leads/{id}/rfq", "GET|POST /grok/wa/keywords", "GET|POST /grok/wa/webhooks", "GET  /grok/wa/report",
];

export default function GrokBotPage() {
  const [flags, setFlags] = useState(null);
  const [report, setReport] = useState(null);
  const [busy, setBusy] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const load = useCallback(async () => {
    try {
      const [f, r] = await Promise.all([fetchGrokFlags(), fetchGrokReport()]);
      setFlags(f); setReport(r); setReloadKey((k) => k + 1);
    } catch { toast.error("Could not load Grok Bot data"); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const act = async (fn, msg) => {
    setBusy(true);
    try { const r = await fn(); if (msg) toast.success(typeof msg === "function" ? msg(r) : msg); await load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Action failed"); }
    finally { setBusy(false); }
  };

  return (
    <Shell title="Grok Bot" subtitle="Lead pipeline + bot API. Every flag starts off and in dry-run.">
      {!flags ? (
        <div className="text-sm text-zinc-400" data-testid="grok-loading">Loading…</div>
      ) : (
        <>
          <FlagsPanel flags={flags} busy={busy} onSave={(patch) => act(() => updateGrokFlags(patch), "Saved")} />
          <ReportPanel report={report} busy={busy} onRefresh={() => act(async () => {}, "Report refreshed")}
            onBackfill={() => act(() => runGrokBackfill(90), (r) => `${r.leads_created} leads, ${r.duplicates_attached} duplicates, ${r.intros_linked} intros imported`)} />
          <Report7dPanel reloadKey={reloadKey} />
          <DraftsPanel reloadKey={reloadKey} onChanged={load} />
          <LeadsPanel reloadKey={reloadKey} />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            <TokensPanel />
            <WebhooksPanel />
          </div>
          <div className="border border-zinc-100 bg-zinc-50 p-4 text-[11px] text-zinc-500 font-mono-num leading-relaxed" data-testid="grok-api-reference">
            <div className="font-sans font-semibold text-zinc-600 mb-1.5">Base URL: {API} · header Authorization: Bearer cgk_…</div>
            {ENDPOINTS.map((e) => <div key={e}>{e}</div>)}
          </div>
        </>
      )}
    </Shell>
  );
}
